import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto py-8 sm:py-12 px-3 sm:px-6">
      {/* Card */}
      <div className="bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-6 bg-gradient-to-r from-purple-100 via-purple-50 to-white">
          {/* Left - Logo + Title */}
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-12 sm:w-14 h-12 sm:h-14 rounded-lg bg-purple-300/20 ring-1 ring-purple-300">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 sm:w-7 sm:h-7 text-purple-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h18v4H3z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 7l3 13h12l3-13" />
              </svg>
            </div>

            <div>
              <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                Shipping & Delivery Policy
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Aavryaafabhub — Fast, safe, and careful delivery for premium fabrics.
              </p>
            </div>
          </div>

          {/* Right - Buttons */}
          <div className="flex flex-wrap sm:flex-nowrap items-center gap-3">
            <a
              href="mailto:aavryaafabhub@gmail.com"
              className="px-3 sm:px-4 py-2 rounded-lg bg-purple-300/20 text-purple-700 ring-1 ring-purple-100 hover:bg-purple-300/30 text-sm sm:text-base"
            >
              Email Us
            </a>
            <a
              href="https://wa.me/919944592904"
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 sm:px-4 py-2 rounded-lg bg-purple-600 text-white hover:opacity-95 text-sm sm:text-base"
            >
              WhatsApp
            </a>
          </div>
        </div>

        {/* Body */}
        <div className="p-5 sm:p-8">
          <p className="text-gray-600 mb-4 text-sm sm:text-base">
            At <strong>AavryaaFabHub</strong>, we ensure every fabric is packed securely
            and shipped promptly to reach you in pristine condition.
          </p>

          {/* Pills */}
          <div className="flex flex-wrap gap-2 mb-6">
            {[
              "🚚 2–3 day dispatch",
              "📦 Secure packaging",
              "🌍 Pan-India delivery"
            ].map((pill, i) => (
              <span
                key={i}
                className="inline-block bg-purple-50 text-purple-700 text-xs sm:text-sm font-medium px-3 py-1 rounded-full ring-1 ring-purple-100"
              >
                {pill}
              </span>
            ))}
          </div>

          {/* Sections */}
          {[
            {
              title: "1. Dispatch Timeline",
              content: [
                "Orders are typically processed and dispatched within 2–3 business days.",
                "During peak seasons or sales, dispatch time may extend slightly."
              ]
            },
            {
              title: "2. Delivery Partners",
              content: [
                "We work with trusted courier services to ensure timely delivery.",
                "Tracking details are shared via email/SMS once the order is shipped."
              ]
            },
            {
              title: "3. Shipping Charges",
              content: [
                "Free shipping on orders above ₹999 within India.",
                "For orders below ₹999, a nominal shipping fee applies."
              ]
            },
            {
              title: "4. International Shipping",
              paragraph: [
                "Currently, we ship only within India. International orders are not supported at the moment."
              ]
            },
            {
              title: "5. Delivery Issues",
              content: [
                "If your package is delayed beyond the expected time, contact our support team.",
                "Damaged packages should be reported within 48 hours with photos."
              ]
            }
          ].map((sec, idx) => (
            <section className="mb-6" key={idx}>
              <h2 className="text-base sm:text-lg font-semibold text-gray-800 mb-2">
                {sec.title}
              </h2>
              {sec.paragraph ? (
                sec.paragraph.map((p, i) => (
                  <p key={i} className="text-gray-600 text-sm sm:text-base mb-2">
                    {p}
                  </p>
                ))
              ) : (
                <ul className="list-disc pl-6 text-gray-600 space-y-2 text-sm sm:text-base">
                  {sec.content.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              )}
            </section>
          ))}

          {/* CTA */}
          <div className="mt-4 border-t pt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="text-gray-600 text-xs sm:text-sm">
                Need help with your delivery? Contact our support:
              </p>
              <div className="mt-2 flex flex-wrap items-center gap-3">
                <a
                  href="tel:+919944592904"
                  className="text-gray-800 font-medium hover:underline text-sm sm:text-base"
                >
                  📞 +91 99445 92904
                </a>
                <a
                  href="mailto:aavryaafabhub@gmail.com"
                  className="text-purple-700 font-medium hover:underline text-sm sm:text-base"
                >
                  ✉️ aavryaafabhub@gmail.com
                </a>
              </div>
            </div>

            <a
              href="https://wa.me/919944592904?text=Hi%20I%20need%20help%20with%20my%20shipping"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block rounded-lg px-4 py-2 bg-purple-600 text-white shadow-sm hover:bg-purple-700 text-sm sm:text-base"
            >
              Chat on WhatsApp
            </a>
          </div>

          <p className="text-xs sm:text-sm text-gray-400 mt-4">
            📅 Last Updated: August 11, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
